import { combineReducers } from "redux";
import fetchReducer from "../common/fetch";
import createNamedWrapperReducer from "../common/utils";

export default combineReducers({
  commission: createNamedWrapperReducer(fetchReducer, "commission-members"),
});
